import {
  Grid,
  Stack,
  TypographyProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ArticleMeta from '../../types/ArticleMeta';
import { ArticleCardLocation } from '../../utilities/gtm';
import ArticleCard from '../ArticleCard/ArticleCard';
import { ArticleCardVariant } from '../ArticleCard/CardUtils';

interface ArticleListProps {
  readonly articles: ArticleMeta[];
  readonly location: ArticleCardLocation;
  readonly heading?: TypographyProps['component'];
  readonly showGrid?: boolean;
  readonly showOnlyCustomCoverImages?: boolean;
  readonly hideCoverImages?: boolean;
  readonly columns?: number;
  readonly cardVariant?: ArticleCardVariant;
}

export default function ArticleList({
  articles,
  showGrid = false,
  showOnlyCustomCoverImages = false,
  hideCoverImages = false,
  location,
  heading,
  cardVariant,
  columns = 2,
}: ArticleListProps) {
  const theme = useTheme();
  const showLargeVariant = useMediaQuery(theme.breakpoints.up('sm'));
  const variant = cardVariant ?? (showLargeVariant ? 'default' : 'mobile');

  return (
    <>
      {showGrid === false && (
        <Stack
          component='ol'
          useFlexGap
          sx={{
            padding: 0,
            margin: 0,
            gap: 1,
            listStyleType: 'none',
          }}
        >
          {articles.map((article, index) => (
            <Stack component='li' key={article.id}>
              <ArticleCard
                meta={article}
                heading={heading}
                gtmData={{ index, location }}
                variant={variant}
                showOnlyCustomCoverImage={showOnlyCustomCoverImages}
                hideCoverImage={hideCoverImages}
              />
            </Stack>
          ))}
        </Stack>
      )}
      {showGrid && (
        <Grid
          component='ol'
          container
          columnSpacing={3}
          rowSpacing={2}
          sx={{ listStyleType: 'none', padding: 0, marginY: 0, marginX: -1.5 }}
        >
          {articles.map((article, index) => (
            <Grid
              component='li'
              key={article.id}
              size={{ xs: 12, md: 12 / columns }}
            >
              <ArticleCard
                meta={article}
                heading={heading}
                gtmData={{ index, location }}
                showOnlyCustomCoverImage={showOnlyCustomCoverImages}
                variant={variant}
                hideCoverImage={hideCoverImages}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}
